var UIInput = (function ($) {

    UIInput = function () {
        var that = this;

        // DOM

        // CONST

        // DYNAMIC VARS

        // INIT
        that.init();
    };

    UIInput.prototype.class = {
        focus: 'focus',
        not_empty: 'not-empty',
        error: 'error',
        success: 'success',
        manual: 'manual',
        is_active: 'is-active',
        not_disabled: 'not-disabled'
    };

    UIInput.prototype.init = function () {
        var that = this;

        //
        that.initEventHandlers();
    };

    UIInput.prototype.initEventHandlers = function () {
        var that = this;

        $.sa.$document.on('click', '.js-password-toggle', function (e) {
            var $password_toggle = $(this),
                $input_wrapper = $password_toggle.parent('.input'),
                $input = $input_wrapper.find('input');

            $input_wrapper.find(e.handleObj.selector).toggleClass(that.class.is_active);

            $input.prop('type', $input.prop('type') === "password" ? 'text' : 'password')

            return false;
        });

        $.sa.$document.on('click', '.js-input-clear', function (e) {
            var $input_clear = $(this),
                $input_wrapper = $input_clear.parent('.input'),
                $input = $input_wrapper.find('input');

            that.clearInput($input);
        });

        $.sa.$document.on('click', '.input', function (e) {
            var $target = $(e.target),
                $input_wrapper = $(this),
                $input = $input_wrapper.find('input');

            if (!$target.is('input') && !$input.is(':disabled') && !$input.is(':read-only')) {
                $input.focus();
            }
        });

        $.sa.$document.on('focus', '.input input', function (e) {
            var $input = $(this),
                $input_wrapper = $input.parents('.input');

            if ($input.is(':read-only')) {
                e.preventDefault();
                return false;
            }

            if (!!$input.val() || $input.attr('type') === 'date') {
                $input_wrapper.addClass(that.class.not_empty);
            }
            $input_wrapper.addClass(that.class.focus);
        });

        $.sa.$document.on('focusout', '.input input', function () {
            var $input = $(this),
                $input_wrapper = $input.parents('.input');

            $input_wrapper.removeClass(that.class.focus);
        });

        $.sa.$document.on('input', '.input input', function () {
            var $input = $(this),
                $input_wrapper = $input.parents('.input');

            if (!$input_wrapper.hasClass(that.class.manual)) {
                that.clearError($input);
            }
        });
    };
    
    UIInput.prototype.setNotEmpty = function ($input, not_empty) {
        var that = this,
            $input_wrapper = $input.parents('.input, .checkbox');
        
        $input_wrapper.toggleClass(that.class.not_empty, not_empty);
    };

    UIInput.prototype.setError = function ($input, error_text = null, manual = false) {
        var that = this,
            $input_wrapper = $input.parents('.input, .checkbox'),
            $error = $input_wrapper.find('.error');

        $input_wrapper.addClass(that.class.error);

        if (manual === true) {
            $input_wrapper.addClass(that.class.manual);
        }

        if (null === error_text) {
            error_text = $input.data('error-text');
        }
        if (error_text) {
            $error.text(error_text).attr("title", error_text);
        }
    };

    /**
     * Append multiple errors to input
     * @param {jQuery} $input
     * @param {[]} errors_list
     * @param {boolean} manual
     */
    UIInput.prototype.appendErrors = function ($input, errors_list, manual = false) {
        var that = this,
            $input_wrapper = $input.parents('.input, .checkbox'),
            $error = $input_wrapper.find('.error'),
            error_text_default = $input.data('error-text');

        $input_wrapper.addClass(that.class.error);

        if (manual === true) {
            $input_wrapper.addClass(that.class.manual);
        }

        if (!Array.isArray(errors_list) || !errors_list.length) {
            if (error_text_default) {
                errors_list = [error_text_default];
            } else {
                errors_list = [];
            }
        }

        errors_list.forEach(function (error_text) {
            $error.append($('<div />').addClass('error-msg').text(error_text));
        });
    };

    UIInput.prototype.clearError = function ($input) {
        var that = this,
            $input_wrapper = $input.parents('.input, .checkbox'),
            $error = $input_wrapper.find('.error');

        $input_wrapper
            .removeClass(that.class.error + ' ' + that.class.manual)
            .toggleClass(that.class.not_empty, !!$input.val());

        $error.text("").attr("title", "");
    };

    UIInput.prototype.setSuccess = function ($input, success_text = null, manual = false) {
        var that = this,
            $input_wrapper = $input.parents('.input, .checkbox'),
            $success = $input_wrapper.find('.success');

        $input_wrapper.addClass(that.class.success);

        if (manual === true) {
            $input_wrapper.addClass(that.class.manual);
        }

        if (null === success_text) {
            success_text = $input.data('success-text');
        }
        if (success_text) {
            $success.text(success_text);
        }
    };

    UIInput.prototype.clearSuccess = function ($input) {
        var that = this,
            $input_wrapper = $input.parents('.input, .checkbox'),
            $success = $input_wrapper.find('.success');

        $input_wrapper
            .removeClass(that.class.success + ' ' + that.class.manual)
            .toggleClass(that.class.not_empty, !!$input.val());

        $success.text('');
    };

    UIInput.prototype.clearInput = function ($input) {
        $input.val('').trigger('input').change();
    };

    UIInput.prototype.disable = function ($input) {
        $input.attr('disabled', 'disabled');
    };

    UIInput.prototype.enable = function ($input) {
        $input.removeAttr('disabled');
    };

    return UIInput;
})($);

/**
 * Input Builder Plugin
 * Options:
 *      wrapper_tag = 'label', 'div', etc... (default: div)
 *      wrapper_class = 'full', or other
 *      input_type = 'text', 'phone', 'email', etc... (default: text)
 *      value = 'string'
 *      icon_left = 'fab fa-sa-search' or other
 *      icon_right = 'fab fa-sa-search' or other
 *      placeholder = 'string'
 *      error_text = 'string'
 **/
(function ($) {

    var UIInputBuilder = (function ($) {

        UIInputBuilder = function (options) {
            var that = this;

            that.options = options;

            that.wrapper_tag = (options['wrapper_tag'] || 'div');
            that.input_type = (options['input_type'] || 'text');
            that.wrapper_class = (options['wrapper_class'] || null);
            that.value = (options['value'] || null);
            that.icon_left = (options['icon_left'] || null);
            that.icon_right = (options['icon_right'] || null);
            that.placeholder = (options['placeholder'] || null);
            that.error_text = (options['error_text'] || null);

            return that.build();
        };

        UIInputBuilder.prototype.build = function () {
            var that = this,
                $input_wrapper = $('<' + that.wrapper_tag + ' class="input" />'),
                $input = $('<input type="' + that.input_type + '" autocomplete="off"/>'),
                $error = $('<span class="error" />'),
                $icon_left = null,
                $icon_right = null,
                $placeholder = null;

            if (that.wrapper_class) {
                $input_wrapper.addClass(that.wrapper_class);
            }
            if (that.value) {
                $input.val(that.value);
                $input_wrapper.addClass(UIInput.prototype.class['not_empty']);
            }
            if (that.icon_left) {
                $input_wrapper.addClass('inner-icon-left');
                $icon_left = $('<span class="icon-left"><i class="' + that.icon_left + '"></i></span>');
            }
            if (that.icon_right) {
                $input_wrapper.addClass('inner-icon-right');
                $icon_right = $('<span class="icon-right"><i class="' + that.icon_right + '"></i></span>');
            }
            if (that.placeholder) {
                $placeholder = $('<span class="placeholder">' + that.placeholder + '</span>');
            }
            if (that.error_text) {
                $error.text(that.error_text);
                $input_wrapper.addClass(UIInput.prototype.class['error']);
            }

            $input_wrapper.append($icon_left);
            $input_wrapper.append($input);
            $input_wrapper.append($icon_right);
            $input_wrapper.append($placeholder);
            $input_wrapper.append($error);

            return $input_wrapper;
        };

        return UIInputBuilder;
    })($);

    $.uiInputBuilder = function (plugin_options) {
        plugin_options = (typeof plugin_options === 'object' ? plugin_options : {});
        var options = $.extend(true, {}, plugin_options);
        return new UIInputBuilder(options);
    };

})(jQuery);
